import './../app/shared/operators';

import { of } from 'rxjs/observable/of';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { Action } from '@ngrx/store';
import { Effect, Actions } from '@ngrx/effects';

import * as u from '../actions/user.actions';

import { Api } from '../providers/api/api';
import { Storage } from '@ionic/storage';
import { Store } from '@ngrx/store';
import * as fromRoot from '../reducers'

@Injectable()
export class UserEffects {
  constructor(
    private actions$: Actions,
    private api: Api,
    private storage: Storage,
    private store: Store<fromRoot.State>
  ) {
  }

  @Effect()
  saveFlex$: Observable<Action> = this.actions$
  .ofType(u.SAVE_FLEX)
  .map((action: u.SaveFlex) => {
    return action.payload;
  })
  .switchMap((payload) => this.api.saveFlex(payload.ticker, payload.user_id, payload.flex))
  .map(user => {
    this.storage.set('user', user);
    return new u.SaveFlexSuccess(user);
  }).catch((err) => of(new u.SaveFlexFailure(err)));

  @Effect()
  toggleFlex$: Observable<Action> = this.actions$
  .ofType(u.TOGGLE_FLEX)
  .map((action: u.ToggleFlex) => {
    return action.payload;
  })
  .withLatestFrom(this.store)
  .switchMap(([payload, storeState]) => {
    return this.api.saveFlex(payload.ticker, storeState.user._id, storeState.user.flexes[payload.ticker])
  })
  .map(user => {
    this.storage.set('user', user);
    return new u.SaveFlexSuccess(user);
  }).catch((err) => of(new u.SaveFlexFailure(err)));
}



// WEBPACK FOOTER //
// ./src/effects/user.effect.ts